import { trackModified, trackPrint, getPrintedReport, getHistoricalData } from "./workOrderService";
import { mapReportToPrintLog, mapPrintLogToReport } from "./helpers/printMapper";
import { downloadPDF } from "./../helpers/pdfHelper"
import { postAPI } from "../services/api";
import { parseDateToUSFormat } from '../helpers/DateHelper'
import { getDraftLog, upsertDraftLog } from "../services/draftService";

const previousInspection = {
  "Non-Winter Tires": {
    "value": [
      { "name": "Visual Tire Inspection", "value": "NA" }
    ]
  },
  "Winter Tires": {
    "value": [
      { "name": "Visual Tire Inspection", "value": "NA" }
    ]
  },
  "Alignment": {
    "value": [
      { "name": "Visual Alignment Inspection", "value": "NA" }
    ]
  },
  "Steering and Suspension Components": {
    "value": [
      { "name": "Visual Inspection of Front End Components", "value": "NA" },
      { "name": "Visual Inspection of Shocks and/or Struts", "value": "NA" }
    ]
  },
  "Brakes": {
    "value": [
      { "name": "Visual Inspection of Front Brakes", "value": "NA" },
      { "name": "Visual Inspection of Rear Brakes", "value": "NA" }
    ]
  },
  "Battery": {
    "value": [
      { "name": "Visual Battery Inspection and Load Test", "value": "NA" },
    ]
  },
  "date": "",
  "storeId": "",
  "workOrderId": "",
  "invoiceNumber": "",
  "quoteNumber": ""
};


export const getPrintLogReport = async (workOrder) => {
  const printLog = await getPrintedReport(
    workOrder.StoreId,
    workOrder.WorkOrder
  );
  return mapPrintLogToReport(printLog);
};
export const getDraftLogReport = async (workOrder, storeId) => {
  const draftLog = await getDraftLog(workOrder, storeId);
  return mapPrintLogToReport(draftLog);
};

export const upsertDraftLogReport = async (report) => {
  try {
    const printLog = mapReportToPrintLog(report);
    const response = await upsertDraftLog(printLog);
    return response;
  } catch (error) {
    console.error("Error upserting draft log report: ", error);
    throw error;
  }
};

export const generatePrintLogReport = async (report, printOption, isSourcePrint) => {
  try {
    const printLog = mapReportToPrintLog(report);
    const dbWorkOrder = await trackPrint(printLog, printOption, isSourcePrint);
    // Verify if the inspection report has been printed
    if(dbWorkOrder?.isInvalid) {
      return { isInvalid: true, message: dbWorkOrder.description };
    }
    // If it's the first time printing the report, set the variable to print again for the curren session
    sessionStorage.setItem('isSourcePrint', true)
    if(printOption) await generateInspectionPDF(dbWorkOrder);
  } catch (error) {
    console.error("Error generating print log report: ", error);
    throw error;
  }
};

export const hasAnyRedSliderSelected = (report) => {
  return report.categories.some((category) => {
    return category.subCategories.some((subCategory) => {
      return subCategory.value === "Red";
    });
  });
}

export const modifiedWorkOrder = async (workOrder) => {
  await updateModifiedWO(workOrder.StoreId, workOrder.WorkOrder);
};

export const createInspectionFile = async (storeId, workOrderId) => {
  const route = `generateInspectionPdf/${storeId}/${workOrderId}`;
  try{
    console.log(`Generating PDF inspection for WO ${workOrderId}`);
    const response = await postAPI("", route, "");
    return response.json();
  } catch(error){
    console.log(error);
    throw error;
  }
}

const generateInspectionPDF = async (workOrder) => {
  try {
    const doc = await createInspectionFile(workOrder.StoreId, workOrder.WorkOrder);
    downloadPDF(doc.pdfData, workOrder.PtscFlag === "N" ? "Safety Status Check Report.pdf" : "Safety Check Report.pdf");
  } catch (error) {
    console.error('Error: ', error);
    throw error;
  }
}

const updateModifiedWO = async (storeId, workOrderId) => {
  try {
    await trackModified(storeId, workOrderId);
  } catch (error) {
    console.log(error);
  }
};

export const fetchPreviousVisits = async (license, state, storeId) => {
  let previousVisits = {}
  let date = ''
  try {
    const historicalData = await getHistoricalData(license, state, storeId);
    if (historicalData && !historicalData.isInvalid && historicalData.length > 0) {
      previousVisits = mapPreviousInspection(previousInspection, historicalData[0])
      date = parseDateToUSFormat(historicalData[0].date)
    }
  } catch (error) {
    console.log(error);
  } finally {
    return { categories: previousVisits, lastVisitDate: date }
  }
}

const mapPreviousInspection = (emptyPreviousVisit, previousVisit) => {
  return Object.fromEntries(
    Object.keys(emptyPreviousVisit).map(category => [
      category,
      {
        ...emptyPreviousVisit[category],
        ...(previousVisit[category] || {})
      }
    ])
  )
}

export const isAllowedToPrintAndSendEmail = ({ selectedWO, customerInformation }, { hasAnyRedValue, isEmailPriorityEnabled }) => {
  const customerType = selectedWO.CustomerType || customerInformation?.customerType;
  const { email } = customerInformation || {};

  if (!email || selectedWO.CustomerId?.startsWith("CB")) {
    return { canSendEmail: false, canPrintAndSendEmail: false, title: "PRINT REPORT" };
  }

  switch (customerType) {
    case "Consumer":
    case "Employee":
      if (isEmailPriorityEnabled && hasAnyRedValue) {
        return { canSendEmail: true, canPrintAndSendEmail: false, title: "PRINT REPORT" };
      }
      return { canSendEmail: true, canPrintAndSendEmail: true, title: "PRINT REPORT & SEND EMAIL" };
    case "Business":
    case "Standard":
    case "Fleet":
    case "Fleet Billed":
      return { canSendEmail: true, canPrintAndSendEmail: false, title: "PRINT REPORT" };
    default:
      return { canSendEmail: false, canPrintAndSendEmail: false, title: "PRINT REPORT" };
  }
};

export const verifyContent = (print) => {
  let isAnyValueDifferentFromNA = false;
  
  for (const category of print.categories) {
    for (const subcategory of category.subCategories) {
      // Check for missing values
      if (!subcategory.value) {
        return {
          isValid: false,
          message: `Please complete the "${subcategory.name}" in the ${category.name} section`
        };
      }
      
      // Check for no NA values
      if (subcategory.value !== "NA") {
        isAnyValueDifferentFromNA = true;
      }
      
      // Check for red values without notes
      if (subcategory.value === "Red" && !category.notes) {
        return {
          isValid: false,
          message: `Please add a note explaining why ${subcategory.name} in the ${category.name} section requires immediate attention.`
        };
      }
    }
  }
  
  if (!isAnyValueDifferentFromNA) {
    return {
      isValid: false,
      message: "At least one section must be set to Green, Yellow, or Red to save."
    };
  }
  
  return { isValid: true, message: 'Ok' };
}